import React, { ReactElement, ReactNode, useMemo } from 'react';
import classnames from 'classnames';
import { Icon } from '../../../Icon';
import { StepSizes } from '../Steps';

export interface StepProps {
  active?: boolean;
  className?: string;
  label: ReactNode;
  size?: StepSizes;
  step?: number;
  testId?: string;
  visited?: boolean;
}

export function Step({
  active = false,
  className = '',
  label,
  size = 'default',
  step = 0,
  testId = '',
  visited = false,
}: StepProps): ReactElement {
  const classes = classnames('step', {
    active,
    [className]: !!className,
    visited,
  });

  const content = useMemo(
    () => (visited ? <Icon name="check" /> : step),
    [step, visited],
  );

  return (
    <div className={classes} data-testid={testId}>
      <div className="step__icon">{size !== 'dot' && content}</div>
      <div className="step__label">{label}</div>
    </div>
  );
}
